import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Youtube, Facebook, GitHub } from 'react-feather';
import { getAuth, signOut } from 'firebase/auth';
import '../styles/About.css';
import logo from '../assets/logo1.png';
import AboutDesign from '../assets/about-design1.png';
import Border2 from '../assets/footer1.png';
import JC from '../assets/t7-jc.png';
import Joseph from '../assets/t7-joseph.png';
import Rachel from '../assets/t7-rachel.png';
import Vincent from '../assets/t7-vincent.png';
import Thirdy from '../assets/t7-thirdy.png';

function AboutPage() {
  const [menuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false); // controls logout modal
  const navigate = useNavigate();
  const auth = getAuth();

  // Trigger modal when logout clicked
  const confirmLogout = () => {
    setShowLogoutModal(true);
  };

  // Proceed with logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('user');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="about-page">
      <header className="header-bar">
        <img src={logo} className="header-logo" alt="OnionMap" />
        <nav className={`menu ${menuOpen ? 'active' : ''}`}>
          <ul className="menu-list">
            <li><Link to="/home">HOME</Link></li>
            <li><Link to="/results">RESULTS</Link></li>
            <li><Link to="/manage">MANAGE</Link></li>
            <li>
              <Link
                to="#"
                onClick={confirmLogout}
                className="logout-link"
              >
                LOGOUT
              </Link>
            </li>
          </ul>
        </nav>
      </header>

      <div className="picture-container">
        <img src={AboutDesign} alt="OnionMap" className="onion-design" />
      </div>

      <div className="info-container">
        <h2>TEAM 7</h2>
        <div className="t7-cards">
          <div className="t7-card">
            <img src={JC} alt="JC" />
            <h3>John Carlo</h3>
            <h4>Fernandez</h4>
            <p>Email:</p>
            <q>qjcpfernandez@tip.edu.ph</q>
            <p>Elective:</p>
            <q>Data Science</q>
          </div>
          <div className="t7-card">
            <img src={Joseph} alt="Joseph" />
            <h3>Joseph Bryan</h3>
            <h4>Ferrer</h4>
            <p>Email:</p>
            <q>qjbferrer@tip.edu.ph</q>
            <p>Elective:</p>
            <q>System Administration</q>
          </div>
          <div className="t7-card">
            <img src={Rachel} alt="Rachel" />
            <h3>Rachel Joy</h3>
            <h4>Pineda</h4>
            <p>Email:</p>
            <q>qrjdpineda@tip.edu.ph</q>
            <p>Elective:</p>
            <q>Intelligent Systems</q>
          </div>
          <div className="t7-card">
            <img src={Vincent} alt="Vincent" />
            <h3>Vincent Gon</h3>
            <h4>Serrano</h4>
            <p>Email:</p>
            <q>qvgbserrano@tip.edu.ph</q>
            <p>Elective:</p>
            <q>Intelligent Systems</q>
          </div>
          <div className="t7-card">
            <img src={Thirdy} alt="Thirdy" />
            <h3>Armando</h3>
            <h4>Vinluan III</h4>
            <p>Email:</p>
            <q>qamvinluan@tip.edu.ph</q>
            <p>Elective:</p>
            <q>Data Science</q>
          </div>
        </div>

        <div className="contact-us">
          <h2>CONTACT US</h2>
          <div className="contact-icons">
            <a href="mailto:qjbferrer@tip.edu.ph" target="_blank" rel="noopener noreferrer">
              <Mail className="contact-icon email" />
            </a>
            <a href="https://youtube.com/@josephbryan5940" target="_blank" rel="noopener noreferrer">
              <Youtube className="contact-icon youtube" />
            </a>
            <a href="https://facebook.com/josephbryanferrer.20" target="_blank" rel="noopener noreferrer">
              <Facebook className="contact-icon facebook" />
            </a>
            <a href="https://github.com/qjbferrer" target="_blank" rel="noopener noreferrer">
              <GitHub className="contact-icon github" />
            </a>
          </div>
        </div>
      </div>

      <footer className="footer">
        <img src={Border2} alt="Bottom Border" className="footer-image" />
      </footer>

      {/* ===== Logout Confirmation Modal ===== */}
      {showLogoutModal && (
        <div className="delete-confirm-modal">
          <div className="delete-confirm-content">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to log out of your account?</p>
            <div className="delete-confirm-buttons">
              <button
                className="delete-confirm-btn confirm"
                onClick={handleLogout}
              >
                Confirm
              </button>
              <button
                className="delete-confirm-btn cancel"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AboutPage;
